module.exports = __webpack_public_path__ + "static/5-open-source-622aebd02ccf2211c9294a8e72bd98c3.jpg";